export enum LAYOUT_SECTION_NAME {
    HEADER = 'header',
    FOOTER = 'footer',
    BODY = 'body',
}

export enum UI_LINK_TYPE_ENUM {
    PAGE = 'page',
    URL = 'url',
    ANCHOR = 'anchor',
}

export enum SHOP_THEME_NAME {
    PORTAL = 'portal',
    WINDOW = 'window',
    MAGAZINE = 'magazine',
    STORY = 'story',
}

export enum ELEMENT_TYPE {
    GRID_PRIMARY_LEVEL = 'grid-primary-level',
    GRID_SECONDARY_LEVEL = 'grid-secondary-level',
    GRID_SECONDARY_LEVEL_INNER = 'grid-secondary-level-inner',
    CONTENT = 'content',
    RICH_TEXT = 'rich-text',
    BUTTON = 'button',
    IMAGE = 'image',
    VIDEO = 'video',
    SEARCH_BAR = 'search-bar',
    DIVIDER = 'divider',
    COPYRIGHT = 'copyright',
    LOGO = 'logo',
    MENU = 'menu',
    PRODUCT_IMAGE_GALLERY = 'product-image-gallery',
    PRODUCT_INFO_GROUP = 'product-info-group',
    PRODUCT_PROMO_INFO = 'product-promo-info',
    PRODUCT_GIVEAWAY = 'product-giveaway',
    PRODUCT_DESCRIPTION = 'product-description',
    PRODUCT_GROUP = 'product-group',
    PRODUCT_SUGGESTION = 'product-suggestion',
    PRODUCT_SHIPPING_DETAIL = 'product-shipping-detail',
    BREADCRUMB = 'breadcrumb',
    HEADER_SEARCH_BAR = 'header-search-bar',
    FOOTER_KYC_AREA = 'footer-kyc-area',
    FOOTER_CONTACT_INFO = 'footer-contact-info',
    FOOTER_COPYRIGHT = 'footer-copyright',
    CAROUSEL = 'carousel',
    HEADER_LOGIN_ICON = 'header-login-icon',
    HEADER_CART_ICON = 'header-cart-icon',

    // for test
    TEST_ELEMENT = 'test-element',
}

export enum FEATURE_FLAG_KEYS {
    /*
        CSS Variable Type

        表示這些會有相對應的 css variable
        e.q.
            --font-color: #000;
            --hover-font-color: #000;
            --active-font-color: #000;

        利用 style 改變這些 css variable 的值，觸發客製化的計算


        <div style={{
            '--font-color': '#000',
            '--hover-font-color': '#000',
            '--active-font-color': '#000',
        }} className="text-color">
            文字
        </div>

        .text-color {
            color: var(--font-color);

            &:hover {
                color: var(--hover-font-color);
            }

            &:active {
                color: var(--active-font-color);
            }
        }
    */
    FONT_COLOR = 'fontColor',
    FONT_STYLE = 'fontStyle',
    TEXT_ALIGNMENT = 'textAlign',
    TEXT_LETTER_SPACING = 'textLetterSpacing',
    TEXT_LINE_HEIGHT = 'textLineHeight',
    TEXT_BOLD = 'textBold',
    TEXT_ITALIC = 'textItalic',
    TEXT_UNDERLINE = 'textUnderline',
    TEXT_LINE_THROUGH = 'textLineThrough',
    BORDER_COLOR = 'borderColor',
    BORDER_RADIUS = 'borderRadius',
    BACKGROUND_COLOR = 'backgroundColor',
    BOX_SHADOW = 'boxShadow',
    IMAGE_FIT = 'imageFit',
    IMAGE_POSITION = 'imagePosition',
    GRID_COLUMN_1 = 'gridColumn1',
    GRID_COLUMN_2 = 'gridColumn2',
    GRID_COLUMN_3 = 'gridColumn3',
    GRID_COLUMN_4 = 'gridColumn4',
    GRID_ROW_1 = 'gridRow1',
    GRID_ROW_2 = 'gridRow2',
    GRID_ROW_3 = 'gridRow3',
    GRID_ROW_4 = 'gridRow4',
    GRID_GAP = 'gridGap',
    MARGIN_LEFT = 'marginLeft',
    MARGIN_RIGHT = 'marginRight',
    MARGIN_TOP = 'marginTop',
    MARGIN_BOTTOM = 'marginBottom',
    PADDING_LEFT = 'paddingLeft',
    PADDING_RIGHT = 'paddingRight',
    PADDING_TOP = 'paddingTop',
    PADDING_BOTTOM = 'paddingBottom',
    MIN_HEIGHT = 'minHeight',
    GRID_ALIGNMENT = 'justifyContent',
    BUTTON_ICON_TYPE = 'buttonIconType',
    BUTTON_ICON_POSITION = 'buttonIconPosition',
    BORDER_STYLE = 'borderStyle',
    BORDER_WIDTH = 'borderWidth',
    COLOR = 'color',
    ROTATE = 'rotate',
    CELL_WIDTH = 'cellWidth',
    BACKGROUND_MASK_COLOR = 'backgroundMaskColor',

    // hover style
    HOVER_BACKGROUND_COLOR = 'hoverBackgroundColor',
    HOVER_BORDER_COLOR = 'hoverBorderColor',
    HOVER_BORDER_RADIUS = 'hoverBorderRadius',
    HOVER_FONT_COLOR = 'hoverFontColor',
    HOVER_FONT_STYLE = 'hoverFontStyle',
    HOVER_TEXT_BOLD = 'hoverTextBold',
    HOVER_TEXT_ITALIC = 'hoverTextItalic',
    HOVER_TEXT_UNDERLINE = 'hoverTextUnderline',
    HOVER_TEXT_LINE_THROUGH = 'hoverTextLineThrough',

    // active style
    ACTIVE_BACKGROUND_COLOR = 'activeBackgroundColor',
    ACTIVE_BORDER_COLOR = 'activeBorderColor',
    ACTIVE_BORDER_RADIUS = 'activeBorderRadius',
    ACTIVE_FONT_COLOR = 'activeFontColor',
    ACTIVE_FONT_STYLE = 'activeFontStyle',
    ACTIVE_TEXT_BOLD = 'activeTextBold',
    ACTIVE_TEXT_ITALIC = 'activeTextItalic',
    ACTIVE_TEXT_UNDERLINE = 'activeTextUnderline',
    ACTIVE_TEXT_LINE_THROUGH = 'activeTextLineThrough',
    MEDIA_MASK_COLOR = 'mediaMaskColor',

    /*
        Variation Class Type

        表示這些會有相對應的 variation class
        e.q.
            <div className="grid grid-primary-level grid-primary-level--single-cell">
                ...
            </div>

            <div className="grid grid-primary-level grid-primary-level--split-h-3">
                ...
            </div>

        grid-primary-level--single-cell 為已定義的 CSS class
    */
    BUTTON_SIZE = 'buttonSize',
    BUTTON_ALIGNMENT = 'buttonAlign',
    GRID = 'grid',
    HEADER_LAYOUT = 'headerLayout',
    FONT_FAMILY = 'fontFamily',
    FONT_WEIGHT = 'fontWeight',
    FONT_SIZE = 'fontSize',
    MEDIA_ALIGNMENT = 'mediaAlignment',

    /*
        Media Background Type
        
        這些參數若是有數值的話，將會在 component 中生成 absolute 的 Picture 元件，填滿 cell / component 的底，當作是背景。
    */
    READONLY_DEFAULT_IMAGE_URL = 'defaultImageUrl',
    IMAGE_URL = 'imageUrl',
    VIDEO_URL = 'videoUrl',

    /*
        Link Type

        這些參數會在 component 中生成 link 的相關設定
    */
    UI_LINK = 'link',
    UI_LINK_TYPE = 'linkType',
    HYPERLINK = 'hyperlink',

    /*
        Carousel Type
    */
    CAROUSEL_MEDIA_LIST = 'carouselMediaList',
    READONLY_CAROUSEL_MEDIA_LIST = 'readonlyCarouselMediaList',
    CAROUSEL_LINK_TYPE_LIST = 'carouselLinkTypeList',
    CAROUSEL_LINK_LIST = 'carouselLinkList',
    CAROUSEL_SHOULD_OPEN_NEW_WINDOW_LIST = 'carouselShouldOpenNewWindowList',

    /*
        Flag Type - 是否能啟用某些客製化屬性調整
    */
    ENABLE_LINK = 'enableLink',
    PADDING_X = 'buttonPaddingX',
    PADDING_Y = 'buttonPaddingY',
    BUTTON_ICON = 'buttonIcon',
    SHOULD_OPEN_NEW_WINDOW = 'shouldOpenNewWindow',
    FIXED_SCREEN_HEIGHT = 'fixedScreenHeight',
    BACKGROUND_TYPE = 'backgroundType',
    BACKGROUND_COLOR_GRADIENT = 'backgroundColorGradient',
    BACKGROUND_IMAGE = 'backgroundImage',
    BACKGROUND_VIDEO = 'backgroundVideo',
    ENABLE_HOVER_STYLE = 'enableHoverStyle',
    ENABLE_ACTIVE_STYLE = 'enableActiveStyle',
    ENABLE_SHADOW = 'enableShadow',
    HOVER_BACKGROUND_TYPE = 'hoverBackgroundType',
    HOVER_BACKGROUND_COLOR_GRADIENT = 'hoverBackgroundColorGradient',
    ACTIVE_BACKGROUND_TYPE = 'activeBackgroundType',
    ACTIVE_BACKGROUND_COLOR_GRADIENT = 'activeBackgroundColorGradient',

    // 部分元件支援顯示或隱藏內容
    ENABLE_CONTENT = 'enableContent',

    /*
        元件可以脫離 container 限制的寬度
    */
    WITHOUT_CONTAINER_WIDTH = 'withoutContainerWidth',

    /*
        圖片上傳
    */
    MEDIA_TYPE = 'mediaType',
    MEDIA_IMAGE_URL = 'mediaImageUrl',
    MEDIA_IMAGE_EXTERNAL_URL = 'mediaImageExternalUrl',
    MEDIA_VIDEO_URL = 'mediaVideoUrl',
    MEDIA_VIDEO_EXTERNAL_URL = 'mediaVideoExternalUrl',
    MEDIA_WIDTH = 'mediaWidth',
    MEDIA_AUTO_PLAY = 'mediaAutoPlay',
    MEDIA_MUTE = 'mediaMute',
    ENABLE_MEDIA_MASK = 'enableMediaMask',
    MEDIA_ASPECT_RATIO = 'mediaAspectRatio',

    /* 會在 gird 上顯示調整大小的 handle */
    RESIZE_HANDLE = 'resizeHandle',

    /* 會在 gird 上顯示調整 margin 的 handle */
    SPACING_HANDLE = 'spacingHandle',

    /* 可在 component 上使用拖移調整位置 */
    DND_HANDLE = 'dndHandle',

    /* 可使用 panel 進行 content 的內容調整 */
    RICH_TEXT = 'richText',

    /* 允許輸入 preset 以外的 fontSize 值 */
    FONT_SIZE_CUSTOM = 'fontSizeCustom',

    /* 允許使用動畫 */
    ANIMATION = 'animation',

    /* 商品圖片 slide 類型 */
    PRODUCT_IMAGE_GALLERY_TYPE = 'productImageGalleryType',

    /* 商品圖片 slide 方向 */
    PRODUCT_IMAGE_GALLERY_DIRECTION = 'productImageGalleryDirection',

    /* 商品資訊樣式 */
    PRODUCT_INFO_GROUP_TYPE = 'productInfoGroupType',

    /* 特殊元件主按鈕背景顏色 */
    COMPONENT_PRIMARY_BUTTON_BG_COLOR = 'componentPrimaryButtonBgColor',

    /* 特殊元件主按鈕文字顏色 */
    COMPONENT_PRIMARY_BUTTON_TEXT_COLOR = 'componentPrimaryButtonTextColor',

    /* 特殊元件次按鈕背景顏色 */
    COMPONENT_SECONDARY_BUTTON_BG_COLOR = 'componentSecondaryButtonBgColor',

    /* 特殊元件次按鈕文字顏色 */
    COMPONENT_SECONDARY_BUTTON_TEXT_COLOR = 'componentSecondaryButtonTextColor',

    /* 特殊元件折扣標籤背景顏色 */
    COMPONENT_DISCOUNT_BADGE_BG_COLOR = 'componentDiscountBadgeBgColor',

    /* 特殊元件折扣標籤文字顏色 */
    COMPONENT_DISCOUNT_BADGE_TEXT_COLOR = 'componentDiscountBadgeTextColor',

    /* 特殊元件優惠標籤背景顏色 */
    COMPONENT_PROMO_BADGE_BG_COLOR = 'componentPromoBadgeBgColor',

    /* 特殊元件優惠標籤文字顏色 */
    COMPONENT_PROMO_BADGE_TEXT_COLOR = 'componentPromoBadgeTextColor',

    /* 特殊元件贈品標籤背景顏色 */
    COMPONENT_GIVEAWAY_BADGE_BG_COLOR = 'componentGiveawayBadgeBgColor',

    /* 特殊元件贈品標籤文字顏色 */
    COMPONENT_GIVEAWAY_BADGE_TEXT_COLOR = 'componentGiveawayBadgeTextColor',

    /* 特殊元件運費標籤背景顏色 */
    COMPONENT_SHIPPING_BADGE_BG_COLOR = 'componentShippingBadgeBgColor',

    /* 特殊元件運費標籤文字顏色 */
    COMPONENT_SHIPPING_BADGE_TEXT_COLOR = 'componentShippingBadgeTextColor',

    /* 商品頁加價購元件樣式 */
    PRODUCT_CARD_TYPE = 'productCardType',

    /* 商品頁商品描述版型 */
    PRODUCT_DESCRIPTION_TEMPLATE_TYPE = 'productDescriptionTemplateType',

    /* 搜尋匡樣式 */
    SEARCH_BOX_TYPE = 'searchBoxType',

    /* 搜尋匡背景顏色 */
    SEARCH_BOX_BACKGROUND_COLOR = 'searchBoxBackgroundColor',

    /* 搜尋匡邊框顏色 */
    SEARCH_BOX_BORDER_COLOR = 'searchBoxBorderColor',

    /* 搜尋匡邊框圓角 */
    SEARCH_BOX_BORDER_RADIUS = 'searchBoxBorderRadius',

    /* 搜尋匡 icon 顏色 */
    SEARCH_BOX_ICON_COLOR = 'searchBoxIconColor',

    /* 搜尋匡 icon 背景顏色 */
    SEARCH_BOX_ICON_BACKGROUND_COLOR = 'searchBoxIconBackgroundColor',

    /* 搜尋匡 icon 邊框顏色 */
    SEARCH_BOX_ICON_BORDER_COLOR = 'searchBoxIconBorderColor',

    /* 搜尋匡 icon 邊框圓角 */
    SEARCH_BOX_ICON_BORDER_RADIUS = 'searchBoxIconBorderRadius',

    /* 選單 */
    SELECTED_MENU = 'selectedMenu',

    /* 滑鼠移入選單時的文字顏色 */
    HOVER_MENU_TEXT_COLOR = 'hoverMenuTextColor',

    /* 滑鼠點擊選單時的文字顏色 */
    ACTIVE_MENU_TEXT_COLOR = 'activeMenuTextColor',

    /* 響應式選單 */
    RESPONSIVE_MENU_ENABLED = 'responsiveMenuEnabled',

    /* 選單對齊方式 */
    MENU_ALIGNMENT = 'menuAlignment',

    /* 商品組合 */
    PRODUCT_GROUP_CARD_GAP = 'productGroupCardGap',
    PRODUCT_GROUP_CARD_AMOUNT_IN_VIEWPORT = 'productGroupCardAmountInViewport',
    PRODUCT_GROUP_CARD_DISPLAY_TYPE = 'productGroupCardDisplayType',
    PRODUCT_GROUP_USE_PRODUCT_NAME = 'productGroupUseProductName',
    PRODUCT_GROUP_USE_PRODUCT_PRICE = 'productGroupUseProductPrice',
    PRODUCT_GROUP_USE_PRODUCT_BADGE = 'productGroupUseProductBadge',
    PRODUCT_GROUP_SOURCE_TYPE = 'productGroupSourceType',
    PRODUCT_GROUP_SOURCE = 'productGroupSource',
    PRODUCT_GROUP_SOURCE_SORTING_TYPE = 'productGroupSourceSortingType',
    PRODUCT_GROUP_CARD_DISPLAY_AMOUNT = 'productGroupCardDisplayAmount',

    /* 頁首圖示工具 */
    HEADER_ICON_STYLE = 'headerIconStyle',

    /* site style */
    SITE_PAGE_HEADER_ENABLED = 'sitePageHeaderEnabled',
    SITE_WIDTH = 'siteWidth',
    SITE_WIDTH_CUSTOM = 'siteWidthCustom',
    SITE_BACKGROUND_COLOR = 'siteBackgroundColor',
    SITE_BACKGROUND_TYPE = 'siteBackgroundType',
    SITE_BACKGROUND_COLOR_GRADIENT = 'siteBackgroundColorGradient',
    SITE_TOP_LEVEL_FONT_FAMILY = 'siteTopLevelFontFamily',
    SITE_TOP_LEVEL_LARGE_HEADING_FONT_SIZE = 'siteTopLevelLargeHeadingFontSize',
    SITE_TOP_LEVEL_LARGE_HEADING_FONT_WEIGHT = 'siteTopLevelLargeHeadingFontWeight',
    SITE_TOP_LEVEL_LARGE_HEADING_COLOR = 'siteTopLevelLargeHeadingColor',
    SITE_TOP_LEVEL_LARGE_HEADING_LETTER_SPACING = 'siteTopLevelLargeHeadingLetterSpacing',
    SITE_TOP_LEVEL_MEDIUM_HEADING_FONT_SIZE = 'siteTopLevelMediumHeadingFontSize',
    SITE_TOP_LEVEL_MEDIUM_HEADING_FONT_WEIGHT = 'siteTopLevelMediumHeadingFontWeight',
    SITE_TOP_LEVEL_MEDIUM_HEADING_COLOR = 'siteTopLevelMediumHeadingColor',
    SITE_TOP_LEVEL_MEDIUM_HEADING_LETTER_SPACING = 'siteTopLevelMediumHeadingLetterSpacing',
    SITE_TOP_LEVEL_SMALL_HEADING_FONT_SIZE = 'siteTopLevelSmallHeadingFontSize',
    SITE_TOP_LEVEL_SMALL_HEADING_FONT_WEIGHT = 'siteTopLevelSmallHeadingFontWeight',
    SITE_TOP_LEVEL_SMALL_HEADING_COLOR = 'siteTopLevelSmallHeadingColor',
    SITE_TOP_LEVEL_SMALL_HEADING_LETTER_SPACING = 'siteTopLevelSmallHeadingLetterSpacing',
    SITE_TOP_LEVEL_LARGE_PARAGRAPH_FONT_SIZE = 'siteTopLevelLargeParagraphFontSize',
    SITE_TOP_LEVEL_LARGE_PARAGRAPH_FONT_WEIGHT = 'siteTopLevelLargeParagraphFontWeight',
    SITE_TOP_LEVEL_LARGE_PARAGRAPH_COLOR = 'siteTopLevelLargeParagraphColor',
    SITE_TOP_LEVEL_LARGE_PARAGRAPH_LETTER_SPACING = 'siteTopLevelLargeParagraphLetterSpacing',
    SITE_TOP_LEVEL_MEDIUM_PARAGRAPH_FONT_SIZE = 'siteTopLevelMediumParagraphFontSize',
    SITE_TOP_LEVEL_MEDIUM_PARAGRAPH_FONT_WEIGHT = 'siteTopLevelMediumParagraphFontWeight',
    SITE_TOP_LEVEL_MEDIUM_PARAGRAPH_COLOR = 'siteTopLevelMediumParagraphColor',
    SITE_TOP_LEVEL_MEDIUM_PARAGRAPH_LETTER_SPACING = 'siteTopLevelMediumParagraphLetterSpacing',
    SITE_TOP_LEVEL_SMALL_PARAGRAPH_FONT_SIZE = 'siteTopLevelSmallParagraphFontSize',
    SITE_TOP_LEVEL_SMALL_PARAGRAPH_FONT_WEIGHT = 'siteTopLevelSmallParagraphFontWeight',
    SITE_TOP_LEVEL_SMALL_PARAGRAPH_COLOR = 'siteTopLevelSmallParagraphColor',
    SITE_TOP_LEVEL_SMALL_PARAGRAPH_LETTER_SPACING = 'siteTopLevelSmallParagraphLetterSpacing',
}

export const CSSVariablesMap = {
    [FEATURE_FLAG_KEYS.FONT_FAMILY]: '--shop-ui-custom-font-family',
    [FEATURE_FLAG_KEYS.FONT_WEIGHT]: '--shop-ui-custom-font-weight',
    [FEATURE_FLAG_KEYS.FONT_SIZE]: '--shop-ui-custom-font-size',
    [FEATURE_FLAG_KEYS.TEXT_ALIGNMENT]: '--shop-ui-custom-text-alignment',
    [FEATURE_FLAG_KEYS.TEXT_LETTER_SPACING]: '--shop-ui-custom-text-letter-spacing',
    [FEATURE_FLAG_KEYS.TEXT_LINE_HEIGHT]: '--shop-ui-custom-text-line-height',
    [FEATURE_FLAG_KEYS.BORDER_RADIUS]: '--shop-ui-custom-border-radius',
    [FEATURE_FLAG_KEYS.COLOR]: '--shop-ui-custom-color',
    [FEATURE_FLAG_KEYS.FONT_COLOR]: '--shop-ui-custom-font-color',
    [FEATURE_FLAG_KEYS.BORDER_COLOR]: '--shop-ui-custom-border-color',
    [FEATURE_FLAG_KEYS.BACKGROUND_COLOR]: '--shop-ui-custom-background-color',
    [FEATURE_FLAG_KEYS.HOVER_BORDER_COLOR]: '--shop-ui-custom-hover-border-color',
    [FEATURE_FLAG_KEYS.HOVER_BACKGROUND_COLOR]: '--shop-ui-custom-hover-background-color',
    [FEATURE_FLAG_KEYS.HOVER_BORDER_RADIUS]: '--shop-ui-custom-hover-border-radius',
    [FEATURE_FLAG_KEYS.HOVER_FONT_COLOR]: '--shop-ui-custom-hover-font-color',
    [FEATURE_FLAG_KEYS.HOVER_FONT_STYLE]: '--shop-ui-custom-hover-font-style',
    [FEATURE_FLAG_KEYS.ACTIVE_FONT_COLOR]: '--shop-ui-custom-active-font-color',
    [FEATURE_FLAG_KEYS.ACTIVE_BORDER_COLOR]: '--shop-ui-custom-active-border-color',
    [FEATURE_FLAG_KEYS.ACTIVE_BACKGROUND_COLOR]:
        '--shop-ui-custom-active-background-color',
    [FEATURE_FLAG_KEYS.ACTIVE_BORDER_RADIUS]: '--shop-ui-custom-active-border-radius',
    [FEATURE_FLAG_KEYS.ACTIVE_FONT_STYLE]: '--shop-ui-custom-active-font-style',
    [FEATURE_FLAG_KEYS.BOX_SHADOW]: '--shop-ui-custom-box-shadow',
    [FEATURE_FLAG_KEYS.GRID_COLUMN_1]: '--shop-ui-custom-grid-column-1',
    [FEATURE_FLAG_KEYS.GRID_COLUMN_2]: '--shop-ui-custom-grid-column-2',
    [FEATURE_FLAG_KEYS.GRID_COLUMN_3]: '--shop-ui-custom-grid-column-3',
    [FEATURE_FLAG_KEYS.GRID_COLUMN_4]: '--shop-ui-custom-grid-column-4',
    [FEATURE_FLAG_KEYS.GRID_ROW_1]: '--shop-ui-custom-grid-row-1',
    [FEATURE_FLAG_KEYS.GRID_ROW_2]: '--shop-ui-custom-grid-row-2',
    [FEATURE_FLAG_KEYS.GRID_ROW_3]: '--shop-ui-custom-grid-row-3',
    [FEATURE_FLAG_KEYS.GRID_ROW_4]: '--shop-ui-custom-grid-row-4',
    [FEATURE_FLAG_KEYS.GRID_GAP]: '--shop-ui-custom-grid-gap',
    [FEATURE_FLAG_KEYS.GRID_ALIGNMENT]: '--shop-ui-custom-grid-alignment',
    [FEATURE_FLAG_KEYS.IMAGE_POSITION]: '--shop-ui-custom-image-position',
    [FEATURE_FLAG_KEYS.IMAGE_FIT]: '--shop-ui-custom-image-fit',
    [FEATURE_FLAG_KEYS.MARGIN_LEFT]: '--shop-ui-custom-margin-left',
    [FEATURE_FLAG_KEYS.MARGIN_RIGHT]: '--shop-ui-custom-margin-right',
    [FEATURE_FLAG_KEYS.MARGIN_TOP]: '--shop-ui-custom-margin-top',
    [FEATURE_FLAG_KEYS.MARGIN_BOTTOM]: '--shop-ui-custom-margin-bottom',
    [FEATURE_FLAG_KEYS.PADDING_LEFT]: '--shop-ui-custom-padding-left',
    [FEATURE_FLAG_KEYS.PADDING_RIGHT]: '--shop-ui-custom-padding-right',
    [FEATURE_FLAG_KEYS.PADDING_TOP]: '--shop-ui-custom-padding-top',
    [FEATURE_FLAG_KEYS.PADDING_BOTTOM]: '--shop-ui-custom-padding-bottom',
    [FEATURE_FLAG_KEYS.MIN_HEIGHT]: '--shop-ui-custom-min-height',
    [FEATURE_FLAG_KEYS.BUTTON_ALIGNMENT]: '--shop-ui-custom-button-alignment',
    [FEATURE_FLAG_KEYS.MENU_ALIGNMENT]: '--shop-ui-custom-menu-alignment',
    [FEATURE_FLAG_KEYS.PADDING_X]: '--shop-ui-custom-button-padding-x',
    [FEATURE_FLAG_KEYS.PADDING_Y]: '--shop-ui-custom-button-padding-y',
    [FEATURE_FLAG_KEYS.MEDIA_WIDTH]: '--shop-ui-custom-media-width',
    [FEATURE_FLAG_KEYS.MEDIA_ALIGNMENT]: '--shop-ui-custom-media-alignment',
    [FEATURE_FLAG_KEYS.BORDER_WIDTH]: '--shop-ui-custom-border-width',
    [FEATURE_FLAG_KEYS.BORDER_STYLE]: '--shop-ui-custom-border-style',
    [FEATURE_FLAG_KEYS.SITE_WIDTH]: '--shop-ui-custom-site-width',
    [FEATURE_FLAG_KEYS.SITE_BACKGROUND_COLOR]: '--shop-ui-custom-site-background-color',
    [FEATURE_FLAG_KEYS.SITE_BACKGROUND_TYPE]: '--shop-ui-custom-site-background-type',
    [FEATURE_FLAG_KEYS.SITE_BACKGROUND_COLOR_GRADIENT]:
        '--shop-ui-custom-site-background-color-gradient',
    [FEATURE_FLAG_KEYS.COMPONENT_PRIMARY_BUTTON_BG_COLOR]:
        '--shop-ui-custom-component-primary-button-bg-color',
    [FEATURE_FLAG_KEYS.COMPONENT_PRIMARY_BUTTON_TEXT_COLOR]:
        '--shop-ui-custom-component-primary-button-text-color',
    [FEATURE_FLAG_KEYS.COMPONENT_SECONDARY_BUTTON_BG_COLOR]:
        '--shop-ui-custom-component-secondary-button-bg-color',
    [FEATURE_FLAG_KEYS.COMPONENT_SECONDARY_BUTTON_TEXT_COLOR]:
        '--shop-ui-custom-component-secondary-button-text-color',
    [FEATURE_FLAG_KEYS.COMPONENT_DISCOUNT_BADGE_BG_COLOR]:
        '--shop-ui-custom-component-discount-badge-bg-color',
    [FEATURE_FLAG_KEYS.COMPONENT_DISCOUNT_BADGE_TEXT_COLOR]:
        '--shop-ui-custom-component-discount-badge-text-color',
    [FEATURE_FLAG_KEYS.COMPONENT_PROMO_BADGE_BG_COLOR]:
        '--shop-ui-custom-component-promo-badge-bg-color',
    [FEATURE_FLAG_KEYS.COMPONENT_PROMO_BADGE_TEXT_COLOR]:
        '--shop-ui-custom-component-promo-badge-text-color',
    [FEATURE_FLAG_KEYS.COMPONENT_GIVEAWAY_BADGE_BG_COLOR]:
        '--shop-ui-custom-component-giveaway-badge-bg-color',
    [FEATURE_FLAG_KEYS.COMPONENT_GIVEAWAY_BADGE_TEXT_COLOR]:
        '--shop-ui-custom-component-giveaway-badge-text-color',
    [FEATURE_FLAG_KEYS.COMPONENT_SHIPPING_BADGE_BG_COLOR]:
        '--shop-ui-custom-component-shipping-badge-bg-color',
    [FEATURE_FLAG_KEYS.COMPONENT_SHIPPING_BADGE_TEXT_COLOR]:
        '--shop-ui-custom-component-shipping-badge-text-color',
    [FEATURE_FLAG_KEYS.SEARCH_BOX_BACKGROUND_COLOR]:
        '--shop-ui-custom-search-box-background-color',
    [FEATURE_FLAG_KEYS.SEARCH_BOX_BORDER_COLOR]:
        '--shop-ui-custom-search-box-border-color',
    [FEATURE_FLAG_KEYS.SEARCH_BOX_BORDER_RADIUS]:
        '--shop-ui-custom-search-box-border-radius',
    [FEATURE_FLAG_KEYS.SEARCH_BOX_ICON_COLOR]: '--shop-ui-custom-search-box-icon-color',
    [FEATURE_FLAG_KEYS.SEARCH_BOX_ICON_BACKGROUND_COLOR]:
        '--shop-ui-custom-search-box-icon-background-color',
    [FEATURE_FLAG_KEYS.SEARCH_BOX_ICON_BORDER_COLOR]:
        '--shop-ui-custom-search-box-icon-border-color',
    [FEATURE_FLAG_KEYS.SEARCH_BOX_ICON_BORDER_RADIUS]:
        '--shop-ui-custom-search-box-icon-border-radius',
    [FEATURE_FLAG_KEYS.HOVER_MENU_TEXT_COLOR]: '--shop-ui-custom-hover-menu-text-color',
    [FEATURE_FLAG_KEYS.ACTIVE_MENU_TEXT_COLOR]: '--shop-ui-custom-active-menu-text-color',
    [FEATURE_FLAG_KEYS.PRODUCT_GROUP_CARD_GAP]: '--shop-ui-custom-product-card-list-gap',
    [FEATURE_FLAG_KEYS.PRODUCT_GROUP_CARD_AMOUNT_IN_VIEWPORT]:
        '--shop-ui-custom-product-card-list-items',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_FONT_FAMILY]:
        '--shop-ui-top-level-custom-font-family',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_LARGE_HEADING_FONT_SIZE]:
        '--shop-ui-top-level-custom-large-heading',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_LARGE_HEADING_FONT_WEIGHT]:
        '--shop-ui-top-level-custom-large-heading-weight',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_LARGE_HEADING_COLOR]:
        '--shop-ui-top-level-custom-large-heading-color',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_LARGE_HEADING_LETTER_SPACING]:
        '--shop-ui-top-level-custom-large-heading-letter-spacing',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_MEDIUM_HEADING_FONT_SIZE]:
        '--shop-ui-top-level-custom-medium-heading',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_MEDIUM_HEADING_FONT_WEIGHT]:
        '--shop-ui-top-level-custom-medium-heading-weight',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_MEDIUM_HEADING_COLOR]:
        '--shop-ui-top-level-custom-medium-heading-color',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_MEDIUM_HEADING_LETTER_SPACING]:
        '--shop-ui-top-level-custom-medium-heading-letter-spacing',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_SMALL_HEADING_FONT_SIZE]:
        '--shop-ui-top-level-custom-small-heading',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_SMALL_HEADING_FONT_WEIGHT]:
        '--shop-ui-top-level-custom-small-heading-weight',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_SMALL_HEADING_COLOR]:
        '--shop-ui-top-level-custom-small-heading-color',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_SMALL_HEADING_LETTER_SPACING]:
        '--shop-ui-top-level-custom-small-heading-letter-spacing',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_LARGE_PARAGRAPH_FONT_SIZE]:
        '--shop-ui-top-level-custom-large-paragraph',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_LARGE_PARAGRAPH_FONT_WEIGHT]:
        '--shop-ui-top-level-custom-large-paragraph-weight',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_LARGE_PARAGRAPH_COLOR]:
        '--shop-ui-top-level-custom-large-paragraph-color',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_LARGE_PARAGRAPH_LETTER_SPACING]:
        '--shop-ui-top-level-custom-large-paragraph-letter-spacing',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_MEDIUM_PARAGRAPH_FONT_SIZE]:
        '--shop-ui-top-level-custom-medium-paragraph',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_MEDIUM_PARAGRAPH_FONT_WEIGHT]:
        '--shop-ui-top-level-custom-medium-paragraph-weight',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_MEDIUM_PARAGRAPH_COLOR]:
        '--shop-ui-top-level-custom-medium-paragraph-color',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_MEDIUM_PARAGRAPH_LETTER_SPACING]:
        '--shop-ui-top-level-custom-medium-paragraph-letter-spacing',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_SMALL_PARAGRAPH_FONT_SIZE]:
        '--shop-ui-top-level-custom-small-paragraph',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_SMALL_PARAGRAPH_FONT_WEIGHT]:
        '--shop-ui-top-level-custom-small-paragraph-weight',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_SMALL_PARAGRAPH_COLOR]:
        '--shop-ui-top-level-custom-small-paragraph-color',
    [FEATURE_FLAG_KEYS.SITE_TOP_LEVEL_SMALL_PARAGRAPH_LETTER_SPACING]:
        '--shop-ui-top-level-custom-small-paragraph-letter-spacing',
    [FEATURE_FLAG_KEYS.CELL_WIDTH]: '--shop-ui-custom-fixed-grid-cell-width',
    [FEATURE_FLAG_KEYS.ROTATE]: '--shop-ui-custom-primary-grid-rotate',
} as const;

export const variationClassMap = {
    [ELEMENT_TYPE.GRID_PRIMARY_LEVEL]: FEATURE_FLAG_KEYS.GRID,
    [ELEMENT_TYPE.GRID_SECONDARY_LEVEL]: FEATURE_FLAG_KEYS.GRID,
    [ELEMENT_TYPE.RICH_TEXT]: FEATURE_FLAG_KEYS.RICH_TEXT,
    [ELEMENT_TYPE.BUTTON]: FEATURE_FLAG_KEYS.ENABLE_SHADOW,
} as const;

export const richTextStyleMap = {
    [FEATURE_FLAG_KEYS.TEXT_BOLD]: 'text-bold',
    [FEATURE_FLAG_KEYS.TEXT_ITALIC]: 'text-italic',
    [FEATURE_FLAG_KEYS.TEXT_UNDERLINE]: 'text-underline',
    [FEATURE_FLAG_KEYS.TEXT_LINE_THROUGH]: 'text-line-through',
    [FEATURE_FLAG_KEYS.FONT_SIZE]: FEATURE_FLAG_KEYS.FONT_SIZE,

    [FEATURE_FLAG_KEYS.HOVER_TEXT_BOLD]: 'text-bold--hover',
    [FEATURE_FLAG_KEYS.HOVER_TEXT_ITALIC]: 'text-italic--hover',
    [FEATURE_FLAG_KEYS.HOVER_TEXT_UNDERLINE]: 'text-underline--hover',
    [FEATURE_FLAG_KEYS.HOVER_TEXT_LINE_THROUGH]: 'text-line-through--hover',

    [FEATURE_FLAG_KEYS.ACTIVE_TEXT_BOLD]: 'text-bold--active',
    [FEATURE_FLAG_KEYS.ACTIVE_TEXT_ITALIC]: 'text-italic--active',
    [FEATURE_FLAG_KEYS.ACTIVE_TEXT_UNDERLINE]: 'text-underline--active',
    [FEATURE_FLAG_KEYS.ACTIVE_TEXT_LINE_THROUGH]: 'text-line-through--active',
} as const;

export const productPageUniqueComponentList = [
    ELEMENT_TYPE.PRODUCT_IMAGE_GALLERY,
    ELEMENT_TYPE.PRODUCT_INFO_GROUP,
    ELEMENT_TYPE.PRODUCT_PROMO_INFO,
    ELEMENT_TYPE.PRODUCT_GIVEAWAY,
    ELEMENT_TYPE.PRODUCT_DESCRIPTION,
    ELEMENT_TYPE.PRODUCT_SHIPPING_DETAIL,
    ELEMENT_TYPE.BREADCRUMB,
];

export const productPageRequiredComponentCheckList = [
    ELEMENT_TYPE.PRODUCT_IMAGE_GALLERY,
    ELEMENT_TYPE.PRODUCT_INFO_GROUP,
    ELEMENT_TYPE.PRODUCT_PROMO_INFO,
    ELEMENT_TYPE.PRODUCT_DESCRIPTION,
    ELEMENT_TYPE.PRODUCT_SHIPPING_DETAIL,
];

export const disallowDuplicateSectionNameList = [
    LAYOUT_SECTION_NAME.HEADER,
    LAYOUT_SECTION_NAME.FOOTER,
];

export const disallowDuplicateComponentList = productPageUniqueComponentList;
